/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_price = /** @type {(inputs: {}) => string} */ () => {
	return `Cena`
};

const da_price = /** @type {(inputs: {}) => string} */ () => {
	return `Pris`
};

const de_price = /** @type {(inputs: {}) => string} */ () => {
	return `Preis`
};

const en_price = /** @type {(inputs: {}) => string} */ () => {
	return `Price`
};

const es_price = /** @type {(inputs: {}) => string} */ () => {
	return `Precio`
};

const fr_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prix`
};

const hu_price = /** @type {(inputs: {}) => string} */ () => {
	return `Ár`
};

const it_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prezzo`
};

const nl_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prijs`
};

const pl_price = /** @type {(inputs: {}) => string} */ () => {
	return `Cena`
};

const pt_price = /** @type {(inputs: {}) => string} */ () => {
	return `Preço`
};

const sv_price = /** @type {(inputs: {}) => string} */ () => {
	return `Pris`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const price = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.price(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("price", locale)
	if (locale === "cs") return cs_price(inputs)
	if (locale === "da") return da_price(inputs)
	if (locale === "de") return de_price(inputs)
	if (locale === "en") return en_price(inputs)
	if (locale === "es") return es_price(inputs)
	if (locale === "fr") return fr_price(inputs)
	if (locale === "hu") return hu_price(inputs)
	if (locale === "it") return it_price(inputs)
	if (locale === "nl") return nl_price(inputs)
	if (locale === "pl") return pl_price(inputs)
	if (locale === "pt") return pt_price(inputs)
	return sv_price(inputs)
};